<template>
  <div class="home">
    
    
    <Calendar/>
  </div>
</template>

<script>
// @ is an alias to /src

import Calendar from '@/components/Calendar.vue'

export default {
  name: 'CalendarView',
  components: {
    //HelloWorld,
    Calendar    
  }
}
</script>
<style scoped>
.home{
  height: 100%;
}
.fc{
  height: 100%;
}
</style>
